module.exports = __webpack_public_path__ + "static/media/md-contrast.7f808d2f.svg";